import { Message } from 'element-ui'

/**
 * Flat message class
 */
export class Eva {
  entity: any

  /**
   * Define success alert
   * @param message
   */
  success (message: string): void {
    if (this.entity) {
      this.entity.close()
    }
    this.entity = Message({ message, iconClass: 'fas fa-check-circle', customClass: 'el-message--success' })
  }

  /**
   * Define error alert
   * @param message
   */
  error (message: string): void {
    if (this.entity) {
      this.entity.close()
    }
    this.entity = Message({ message, iconClass: 'fas fa-exclamation-triangle', customClass: 'el-message--error' })
  }

  /**
   * Define info alert
   * @param message
   */
  info (message: string): void {
    if (this.entity) {
      this.entity.close()
    }
    this.entity = Message({ message, iconClass: 'fas fa-info-circle', customClass: 'el-message--info' })
  }
}
